/**
 * InterconnectionRerunPanel — thin wrapper around FeasibilityRerunPanel with
 * connectivity-domain gap categorization (Fiber / Latency / Carriers / IX).
 * Workflow Prompt 6.
 */
import React from 'react';
import { FeasibilityRerunPanel, type RerunPanelProps, type DataGapItem } from './FeasibilityRerunPanel';
import { getGapCategoriesForType } from '../../../lib/rerunGapCategories';

export function InterconnectionRerunPanel(props: RerunPanelProps) {
  return (
    <FeasibilityRerunPanel
      {...props}
      gapCategorizer={(gaps: DataGapItem[]) => getGapCategoriesForType('interconnection', gaps)}
    />
  );
}
